import axios from "axios"

const controller = "/envio"

const EnvioService = {
    buscar: async (request) => {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    registrarEnvios: async (request) => {
        const { data } = await axios.post(`${controller}/registrarEnvios`, request)
        return data
    },
    obtener: async (request) => {
        const { data } = await axios.post(`${controller}/obtener`, request)
        return data
    },
    modificar: async (request) => {
        const { data } = await axios.post(`${controller}/modificar`, request)
        return data
    },
    cambiarSecuenciaEstado: async (request) => {
        const { data } = await axios.post(`${controller}/cambiarSecuenciaEstado`, request)
        return data
    },
    cancelarEnvio: async (request) => {
        const { data } = await axios.post(`${controller}/cancelarEnvio`, request)
        return data
    },
    buscarEnviosxMixers: async (request) => {
        const { data } = await axios.post(`${controller}/buscarEnviosxMixers`, request)
        return data
    },
    generarGuiaRemitente: async (request) => {
        const { data } = await axios.post(`${controller}/generarGuiaRemitente`, request)
        return data
    },
    verGuiaRemitente: async (request) => {
        const { data } = await axios.post(`${controller}/verGuiaRemitente`, request)
        return data
    },
}

export default EnvioService